import React from "react";

/**
 * Compact phase header — designed to fit the wizard within a single
 * viewport without scrolling. On lg+ the title and subtitle sit side
 * by side on one line to save vertical real-estate.
 */
export default function PhaseHeader({ eyebrow, title, subtitle }) {
  return (
    <div className="mb-2 lg:mb-3 max-w-6xl">
      <div className="flex items-baseline flex-wrap gap-x-4 gap-y-1">
        {eyebrow && (
          <div className="flex items-center gap-2 shrink-0">
            <span className="w-5 h-px bg-[color:var(--brand)]" />
            <span className="text-[10px] font-mono uppercase tracking-[0.22em] text-[color:var(--brand)]">
              {eyebrow}
            </span>
          </div>
        )}
        <h1 className="font-display font-bold text-[color:var(--text)] text-xl sm:text-2xl lg:text-3xl leading-tight tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[color:var(--text-mute)] text-xs lg:text-sm max-w-2xl min-w-0 truncate lg:whitespace-normal lg:truncate-none">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}
